import React, { useRef } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

import useAnimate from './primitives/Motion';

import Reveal from './primitives/Reveal';
import WordReveal from './primitives/WordReveal';
import useMediaQuery from '../hooks/useMediaQuery';
import { process } from '../data/site';

const EASE = [0.16, 1, 0.3, 1];

export default function Process() {
    const ref = useRef(null);
    const reduced = !useAnimate();
    const horizontal = useMediaQuery('(min-width: 861px)');

    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ['start 0.8', 'end 0.7']
    });

    const draw = useSpring(scrollYProgress, { stiffness: 120, damping: 32, restDelta: 0.001 });
    const lineStyle = reduced
        ? undefined
        : (horizontal ? { scaleX: draw } : { scaleY: draw });

    return (
        <section className="section process">
            <div className="shell">
                <div className="section-head">
                    <Reveal y={18}>
                        <span className="t-eyebrow">How it works</span>
                    </Reveal>
                    <WordReveal as="h2" className="t-h2" text="One call replaces the juggling act." />
                </div>

                <div className="process__grid" ref={ref}>
                    <div className="process__rail" aria-hidden="true">
                        <motion.span className="process__rail-fill" style={lineStyle} />
                    </div>

                    {process.map((item, i) => (
                        <motion.article
                            className="process__step"
                            key={item.step}
                            initial={reduced ? false : { opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.4 }}
                            transition={{ duration: 0.85, delay: i * 0.12, ease: EASE }}
                        >
                            <span className="process__node" aria-hidden="true" />
                            <span className="process__num">{item.step}</span>
                            <h3 className="t-h3 process__title">{item.title}</h3>
                            <p className="t-body">{item.body}</p>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
